import React from 'react';
import { CheckCircle2, ArrowRight, Play } from 'lucide-react';

export function LogoHero() {
  const benefits = [
    {
      title: "Professional & Unique Design",
      description: "Stand out with custom-crafted logos that reflect your brand's personality"
    },
    {
      title: "Brand Identity Development",
      description: "Comprehensive brand guidelines and identity system"
    },
    {
      title: "Multiple Design Concepts",
      description: "Choose from various unique concepts tailored to your vision"
    },
    {
      title: "Unlimited Revisions",
      description: "We'll refine until you're completely satisfied"
    },
    {
      title: "Quick Turnaround Time",
      description: "Get your designs faster without compromising quality"
    },
    {
      title: "100% Satisfaction Guarantee",
      description: "Your satisfaction is our top priority"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          {/* Left Column - Content */}
          <div className="mb-12 lg:mb-0">
            <div className="space-y-6 mt-5">
              
              
              <h1 className="text-4xl md:text-5xl md:text-center   lg:text-6xl lg:text-left  font-bold tracking-tight">
                Professional Logo
                <span className="block mt-2">
                  Design <span className="text-red-600">Services</span>
                </span>
              </h1>

              <p className="text-lg text-gray-600">
                Your logo is the face of your brand. We create memorable, unique logos 
                that capture your brand's essence and leave a lasting impression on your 
                audience. Our expert designers combine creativity with strategic thinking 
                to deliver logos that stand out.
              </p>

              <div className="flex gap-4">
                <button className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium flex items-center transition-colors">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
                <button className="px-6 py-3 border border-gray-300 hover:border-gray-400 rounded-lg font-medium flex items-center transition-colors">
                  View Portfolio
                </button>
              </div>
            </div>

            <div className="mt-12">
              <div className="grid md:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                  <div 
                    key={index} 
                    className="p-4 bg-white rounded-lg border border-gray-200 hover:shadow-lg transition-shadow duration-200"
                  >
                    <div className="flex items-start space-x-3">
                      <CheckCircle2 className="h-6 w-6 text-red-500 flex-shrink-0 mt-1" />
                      <div>
                        <h3 className="font-medium text-gray-900">{benefit.title}</h3>
                        <p className="text-sm text-gray-500 mt-1">{benefit.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Video */}
          <div className="relative">
            <div className="relative rounded-2xl shadow-2xl overflow-hidden bg-gray-900 aspect-video group">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-900/40 to-black/60 z-10" />
              <iframe 
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/73RwXFjFKeE?si=4bMaXyfqcrMsWq2t" 
                title="Logo Design Process" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowFullScreen
              />
              <div className="absolute inset-0 z-20 flex items-center justify-center">
                <div className="rounded-full bg-red-600 p-4 transform transition-transform duration-200 group-hover:scale-110">
                  <Play className="h-8 w-8 text-white" />
                </div>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -right-16 -bottom-16 w-32 h-32 bg-red-200 rounded-full opacity-20 blur-3xl" />
            <div className="absolute -left-8 -top-8 w-24 h-24 bg-blue-200 rounded-full opacity-20 blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}